import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLanguage, currencies, getAvailableCurrencies, isCurrencyLocked, type Currency } from "@/lib/i18n";

export function CurrencySwitcher() {
  const { currency, setCurrency, detectedCountry } = useLanguage();

  // If currency is locked (single option), hide the switcher entirely
  if (isCurrencyLocked(detectedCountry)) return null;

  const available = getAvailableCurrencies(detectedCountry);
  const filtered = currencies.filter(c => available.includes(c.code));
  const current = filtered.find(c => c.code === currency) || filtered[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-1.5 text-muted-foreground hover:text-foreground px-2">
          <span className="text-sm font-medium">{current?.symbol}</span>
          <span className="hidden sm:inline text-sm font-medium">{current?.code}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[120px]">
        {filtered.map((c) => (
          <DropdownMenuItem
            key={c.code}
            onClick={() => setCurrency(c.code as Currency)}
            className={currency === c.code ? "bg-secondary font-medium" : ""}
          >
            <span className="mr-2">{c.symbol}</span>
            {c.code}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
